import React, { Component } from "react";
import axios from 'axios';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Button from "react-bootstrap/Button";
import MUITable from "../MUITable/MUITable";
import { withRouter } from "react-router";
import EditIcon from '@material-ui/icons/Edit';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import UndoIcon from '@material-ui/icons/Undo';
import CloseIcon from '@material-ui/icons/Close';
import ExportIcon from '@material-ui/icons/CloudDownload';
import Spinner from "react-bootstrap/Spinner";
import { Alert } from "@material-ui/lab";
import moment from 'moment';
import { sortCompareDate } from "../../utils/TableHelper";
import { Checkbox, IconButton, FormControl, InputLabel, Select, MenuItem, ListItemText } from "@material-ui/core";
import EntryForm from "../MakeEntry/EntryForm";
import "./StudentEntries.css";

/**
 * During the render process we create a renderState object; this is it's definition.
 * @typedef {Object} RenderState
 * @property {Array} allEntries - All payday entries in the database
 * @property {Array} entries - The payday entries to be displayed in the table
 * @property {Array} paydayList - The list of unique paydays in the entries
 * @property {Array} studentsByLcfId - The list of students in the entries, indexed by lcf_id
 * @property {Array} studentList - The list of unique students in the entries
 * @property {[number]} gradYearList - The list of unique graduation years in the entries
 * @property {[String]} statusList - The list of unique approval statuses in the entries
 */

class StudentEntries extends Component {

  constructor(props) {
    super(props);
    this.backToTable = this.backToTable.bind(this);
    this.state = {
      selectedSchoolYear: getSchoolYearFromYmd(moment().format("YYYY-MM-DD")),
      selectedPayDay: "-",
      selectedLcfId: 0,
      selectedGradYears: [],
      selectedStatuses: [],
      updatingEntry: false,
      updatingIdx: null,
      entries: props.entries,
      isSaving: false,
      api_error: false
    };
  }

  componentDidMount() {
    this.props.dispatch({ type: "GET_STUDENTS" });
    this.props.dispatch({ type: "GET_ADMIN" });
    axios.get(`/api/student/studententries`)
      .then((res) => {
        this.setState({entries: res.data});
      })
      .catch((error) => {
        console.log("Error fetching entries", error);
        this.setState({api_error: true});
      });
  }

  redirectPage() {
    if (this.props.redirect.redirect === true) {
      return <Redirect to='/opentransactions' />
    }
  }

  render() {

    /** @type {RenderState} */
    let renderState = {
      allEntries: this.state.entries,
      entries: this.state.entries,
      paydayList: null,
      studentsByLcfId: null,
      studentList: null,
      gradYearList: null,
      statusList: null,
    }

    if (this.state.selectedSchoolYear) {
      renderState.entries = renderState.entries.filter(e => getSchoolYearFromYmd(e.pay_day) === this.state.selectedSchoolYear);
    }

    addListsToRenderState(renderState);

    if (this.state.selectedPayDay !== "-" || this.state.selectedLcfId
      || this.state.selectedGradYears.length || this.state.selectedStatuses.length)
    {
      renderState.entries = renderState.entries.filter(e =>
        (this.state.selectedPayDay === '-' || e.pay_day.startsWith(this.state.selectedPayDay))
        && (this.state.selectedLcfId === 0 || e.lcf_id === this.state.selectedLcfId)
        && (this.state.selectedGradYears.length === 0 || this.state.selectedGradYears.includes(e.grad_year))
        && (this.state.selectedStatuses.length === 0
          || this.state.selectedStatuses.includes(e.approval_status)));
    }

    if (this.state.updatingEntry) {
      const stuEntry = renderState.entries[this.state.updatingIdx];
      const stuName = stuEntry.first_name + " " + stuEntry.last_name;
      const stuID = stuEntry.lcf_id;
      return (
      <>
        <div style={{margin: '10px'}}>
          Update entry for {stuName} (LCF ID: {stuID})
        </div>
        <EntryForm
          parent_lcf_id={stuID}
          // parent pass in student info if has
          stu_entry={renderState.entries[this.state.updatingIdx]}
          backButtonFunc={this.backToTable}
        />
      </>);
    }

    const columns = [
      {
        name: "Edit-Approve-Reject",
        label: " ",
        options: {
          filter: false,
          sort: false,
          empty: true,
          customBodyRenderLite: (dataIndex) => this.renderEditColumn(renderState.entries, dataIndex)
        }
      },
      {
        name: "Pay Day", options: {
          filter: true,
          sortCompare: sortCompareDate,
          customBodyRenderLite: (idx) => this.renderPayDayColumn(renderState.entries, idx)
        }
      },
      { name: "First Name", options: { filter: true } },
      { name: "Last Name", options: { filter: false } },
      {
        name: "ID", options: {
          filter: true,
          customBodyRenderLite: (idx) => this.renderIDColumn(renderState.entries, idx)
        }
      },
      { name: "Grad Year", options: { filter: true, sort: true } },
      { name: "School Name", options: { filter: true } },
      { name: "Passing Classes", options: { filter: true } },
      { name: "GPA", options: { filter: true } },
      { name: "Days Punctual", options: { filter: true } },
      { name: "Detention", options: { filter: true } },
      { name: "Activities or Job", options: { filter: true } },
      { name: "Substance Abuse", options: { filter: true } },
      { name: "Service Hours", options: { filter: true } },
      { name: "Hub Attended", options: { filter: true } },
      { name: "Comments", options: { filter: true } }
    ];

    const options = {
      rowsPerPage: 50,
      rowsPerPageOptions: [10, 25, 50, 100, 500],
      sortOrder: { name: 'Pay Day', direction: 'desc' },
      responsive: 'standard',
      fixedSelectColumn: true,
      download: false,
      filter: false,
      search: false,
      print: false,
      viewColumns: false,
      tableBodyHeight: "calc(100vh - 300px)",
      customToolbar: () => this.renderToolbar(renderState)
    };

    return (
      <>
        {this.state.api_error === true && (
          <Alert className="error" style={{}} severity="error">
            An error occurred while attempting to send this data to the server.
            Please try again later.
          </Alert>)}
        <div>
          {this.redirectPage()}
          <div className="dense-table">
            <MUITable
              options={options}
              data={this.getStudentDataTableRow(renderState.entries)}
              columns={columns}
              title={`Payday Entries`} />
          </div>
        </div>
      </>
    );
  }

  backToTable(updatedEntryInfo) {
    if (updatedEntryInfo) {
      const entries = this.state.entries.map((e) => {
        if (updatedEntryInfo.id === e.id) {
          // child doesn't have joined entry info, must merge
          return Object.assign(e, updatedEntryInfo);
        } else {
          return e;
        }
      });
      this.setState({entries: entries});

    }

    this.setState({
      updatingEntry: false,
      updatingIdx: null
    });
  }

  /**
   * Returns the rendering of the toolbar.
   * @param {RenderState} rs
   */
  renderToolbar(rs) {
    const years = getUniqueSchoolYears(rs.allEntries);

    const onYearChange = (e) => {
      this.setState({
        selectedPayDay: "-",
        selectedSchoolYear: e.target.value
      });
    };

    const onPaydayChange = e => {
      this.setState({
        selectedPayDay: e.target.value
      });
    }

    const onStudentChange = e => {
      this.setState({
        selectedLcfId: e.target.value
      });
    }

    const onStatusChange = e => {
      this.setState({
        selectedStatuses: e.target.value.includes("all") ? [] : e.target.value
      });
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', alignContent: 'end' }}>
        <IconButton area-label="download csv" onClick={() => exportStudentEntriesCsv(rs)}>
          <ExportIcon />
        </IconButton>
        <FormControl style={{ width: '120px' }} className="ml-2">
          <InputLabel id="se-school-year-filter">School Year</InputLabel>
          <Select labelId="se-school-year-filter"
            value={this.state.selectedSchoolYear}
            onChange={onYearChange}>
            <MenuItem value={0}>All</MenuItem>
            {
              years.map(year => {
                return <MenuItem key={year} value={year}>{(year - 1)}-{year.toString().substring(2, 4)}</MenuItem>
              })
            }
          </Select>
        </FormControl>

        <FormControl style={{ width: '120px' }} className="ml-2">
          <InputLabel id="se-payday-filter">Pay Day</InputLabel>
          <Select labelId="se-payday-filter"
            value={this.state.selectedPayDay}
            onChange={onPaydayChange}>
            <MenuItem value={"-"}>All</MenuItem>
            {
              rs.paydayList.map(pd => {
                return <MenuItem key={pd} value={pd}>{moment(pd).format("MM/DD/YYYY")}</MenuItem>
              })
            }
          </Select>
        </FormControl>
        <IconButton aria-label="clear" size="small"
          disabled={this.state.selectedPayDay === '-'}
          onClick={() => this.setState({ selectedPayDay: '-' })}
          style={{ height: '26px', marginTop: '18px' }}>
          <CloseIcon fontSize="small" />
        </IconButton>

        <FormControl style={{ width: '180px' }} className="ml-2">
          <InputLabel id="se-student-filter">Student</InputLabel>
          <Select labelId="se-student-filter"
            value={this.state.selectedLcfId}
            onChange={onStudentChange}
            renderValue={v => !v ? 'All' : rs.studentsByLcfId.get(v)?.name}>
            <MenuItem dense value={0}>All</MenuItem>
            {
              rs.studentList.map(s => {
                return <MenuItem key={s.lcfId} value={s.lcfId} dense>
                  <ListItemText primary={s.lastFirstName} secondary={s.paydayCount + " paydays"} />
                </MenuItem>
              })
            }
          </Select>
        </FormControl>
        <IconButton aria-label="clear" size="small"
          disabled={this.state.selectedLcfId === 0}
          onClick={() => this.setState({ selectedLcfId: 0 })}
          style={{ height: '26px', marginTop: '18px' }}>
          <CloseIcon fontSize="small" />
        </IconButton>

        {this.renderGradYearFilter(rs)}

        <FormControl style={{ width: '120px' }} className="ml-2">
          <InputLabel id="se-status-filter">Status</InputLabel>
          <Select labelId="se-status-filter"
            value={this.state.selectedStatuses}
            multiple
            onChange={onStatusChange}
            renderValue={(selected) => selected.join(', ')}>
            <MenuItem value={"all"}>All</MenuItem>
            {rs.statusList.map(status => (
              <MenuItem key={status} value={status}>
                <Checkbox checked={this.state.selectedStatuses.indexOf(status) > -1} />
                <ListItemText primary={status === null ? "pending" : status} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }

  /**
   * Returns the rendering of the toolbar.
   * @param {RenderState} rs
   */
  renderGradYearFilter(rs) {

    const onGradYearChange = e => {
      let years = e.target.value;
      const thisYear = getSchoolYearFromYmd(moment().format('YYYY-MM-DD'));
      const freshmanYear = thisYear + 3;
      if (years.includes(0)) {
        years = [];
      } else if (years.includes(-1)) {
        years = rs.gradYearList.filter(y => y <= freshmanYear);
      } else if (years.includes(-2)) {
        years = rs.gradYearList.filter(y => y > freshmanYear);
      }
      this.setState({
        selectedGradYears: years
      });
    }

    return (
      <FormControl style={{ width: '120px' }}>
        <InputLabel id="se-grad-year-filter">Year</InputLabel>
        <Select
          labelId="se-grad-year-filter"
          multiple
          value={this.state.selectedGradYears}
          onChange={onGradYearChange}
          renderValue={(selected) => selected.join(', ')}>
          <MenuItem value={0}>All</MenuItem>
          <MenuItem value={-1}>High School</MenuItem>
          <MenuItem value={-2}>Middle School</MenuItem>
          {rs.gradYearList.map(year => (
            <MenuItem key={year} value={year}>
              <Checkbox checked={this.state.selectedGradYears.indexOf(year) > -1} />
              <ListItemText primary={year} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  renderEditColumn(entries, idx) {
    if (this.state.isSaving) {
      return (<div style={{ width: '140px' }} className="text-center">
        <Spinner animation="border" size="sm" variant="primary" />
      </div>);
    }

    let e = entries[idx];
    let change_approval = null;
    // if-else to render buttons based on state
    if (e.approval_status == null) {
      change_approval = (
      <>
        <Button
          className="neutral-btn-override"
          variant="outline-primary" size="sm"
          title="approve"
          onClick={() => this.changeApproval(e.id, "approved")}>
          <ThumbUpAltIcon fontSize="small" />
        </Button>
        <Button
          className="neutral-btn-override"
          variant ="outline-primary" size="sm"
          title="reject"
          onClick={() => this.changeApproval(e.id, "rejected")}>
          <ThumbDownAltIcon fontSize="small" />
        </Button>
      </>);
    } else if (e.approval_status === "approved") {
      change_approval = (
        <Button
          variant ="success" size="sm"
          title="revert from approved to pending"
          onClick={() => this.changeApproval(e.id, null)}>
          <UndoIcon fontSize="small" />
        </Button>
      );
    } else if (e.approval_status === "rejected") {
      // changeApproval to null for "pending"
      change_approval = (
        <Button
          variant ="danger" size="sm"
          title="revert from rejected to pending"
          onClick={() => this.changeApproval(e.id, null)}>
          <UndoIcon fontSize="small" />
        </Button>
      );
    }

    return (
      <div style={{ width: '135px' }} className="text-center">
        {change_approval}
        <Button
          className="neutral-btn-override"
          variant="outline-primary" size="sm"
          title="edit"
          onClick={() => {
            this.setState({
              updatingEntry: true,
              updatingIdx: idx
            });
          }}>
          <EditIcon fontSize="small" />
        </Button>
      </div>
    );
  }

  renderPayDayColumn(entries, idx) {
    const data = entries[idx];
    const displayDate = moment(data.pay_day.substring(0, 10)).format('M/D/YY');
    const onClick = (e) => {
      e.preventDefault();
      this.setState({
        selectedPayDay: data.pay_day.substring(0, 10),
        selectedLcfId: 0
      });
    }
    return (<a className="click-to-filter" href="#" onClick={onClick}>{displayDate}</a>);
  }

  renderIDColumn(entries, idx) {
    const data = entries[idx];
    const onClick = (e) => {
      e.preventDefault();
      this.setState({
        selectedPayDay: "-",
        selectedLcfId: data.lcf_id
      });
    }
    return (<a className="click-to-filter" href="#" onClick={onClick}>{data.lcf_id}</a>);
  }

  getStudentDataTableRow(entries) {
    return entries.map(entry => [
      moment(entry.pay_day).format('M/D/YY'),
      entry.first_name,
      entry.last_name,
      entry.lcf_id,
      entry.grad_year.toString().substring(2, 4),
      entry.school_attend,
      entry.pass_class ? "Yes" : "No",
      entry.gpa,
      entry.days_clean_attend,
      entry.had_detention ? "Yes" : "No",
      entry.act_or_job ? "Yes" : "No",
      entry.substance_abuse ? "Yes" : "No",
      entry.service_hrs_met ? "Yes" : "No",
      entry.hw_rm_attended ? "Yes" : "No",
      entry.comments.substring(0, 16) + (entry.comments.length > 16 ? "..." : "")
    ]);
  }

  // pass null for 'changeTo' when reverting to 'pending' (pending = NULL in DB)
  changeApproval(entryID, changeTo) {
    const payload = {
      approval_status: changeTo
    }

    this.setState({isSaving: true});
    axios.put(`/api/entry/change-approval/${entryID}`, payload)
    .then(() => {
      let updated = [...this.state.entries];
      const uidx = updated.findIndex((e) => e.id === entryID);
      updated[uidx].approval_status = changeTo;
      this.setState({ isSaving: false, entries: updated });
    })
    .catch((error) => {
      console.log("Error changing approval status: ", error);
      this.setState({ isSaving: false });
      this.setState({ api_error: true });
      setTimeout(() => this.setState({ api_error: false }), 5000);
    });
  }

}

const caseInsensitive = { sensitivity: 'base' };

function getUniqueSchoolYears(entries) {
  const years = new Set();
  for (const e of entries) {
    years.add(getSchoolYearFromYmd(e.pay_day));
  }
  return Array.from(years).sort().reverse();
}

/** @param {RenderState} rs */
function addListsToRenderState(rs) {
  const paydays = new Set();
  const gradYears = new Set();
  const studentsByLcfId = new Map();
  const statuses = new Set();
  for (const e of rs.entries) {
    const lcfId = Number(e.lcf_id);
    paydays.add(e.pay_day.substring(0, 10));
    gradYears.add(e.grad_year);
    statuses.add(e.approval_status);
    if (studentsByLcfId.has(e.lcf_id)) {
      studentsByLcfId.get(e.lcf_id).paydayCount++;
    } else {
      studentsByLcfId.set(e.lcf_id, {
        lcfId,
        name: `${e.first_name} ${e.last_name}`,
        lastFirstName: `${e.last_name}, ${e.first_name}`,
        paydayCount: 1
      });
    }
  }
  rs.paydayList = Array.from(paydays).sort().reverse();
  rs.studentsByLcfId = studentsByLcfId;
  rs.studentList = Array.from(studentsByLcfId.values()).sort((a, b) => a.lastFirstName.localeCompare(b.lastFirstName, caseInsensitive));
  rs.gradYearList = Array.from(gradYears).sort((a,b) => a - b);
  rs.statusList = Array.from(statuses).sort((a,b) => numberFromStatus(a) - numberFromStatus(b));
}

function getSchoolYearFromYmd(ymd) {
  const month = Number(ymd.substring(5, 7));
  const year = Number(ymd.substring(0, 4)) + (month > 6 ? 1 : 0);
  return year;
}

function sortByStudentName(a, b) {
  const result = a.last_name.localeCompare(b.last_name, caseInsensitive);
  return result != 0 ? result : a.first_name.localeCompare(b.first_name, caseInsensitive);
}

/**
 * Exports the current data in the format needed to process payroll.
 * @param {RenderState} rs
 */
function exportStudentEntriesCsv(rs) {
  const spec = [
    { head: "Legacy ID", prop: "lcf_id" },
    { head: "Grad Year", getter: (row) => row.grad_year.toString().substring(2,4) },
    { head: "Last Name", prop: "last_name" },
    { head: "First Name", prop: "first_name" },
    { head: "Pass All Classes", prop: "pass_class", type: "boolean" },
    { head: "GPA", prop: "gpa" },
    { head: "Days Clean Attend", prop: "days_clean_attend" },
    { head: "Detent Hours", prop: "had_detention", type: "boolean" },
    { head: "Sch Act or Job", prop: "act_or_job", type: "boolean" },
    { head: "Subst Abuse", prop: "substance_abuse", type: "boolean" },
    { head: "Met Svc Hrs", prop: "service_hrs_met", type: "boolean" },
    { head: "HW Rm Attend", prop: "hw_rm_attended", type: "boolean" },
  ];

  const headRow = spec.map(s => s.head).join(",");
  const dataRows = [...rs.entries].sort(sortByStudentName);
  const csvRows = dataRows.map(dataRow => {
    return spec.map(s => {
      const value = s.getter ? s.getter(dataRow) : dataRow[s.prop];
      switch (s.type) {
        case "boolean": return convertToCsvBoolean(value);
        default: return convertToCsvString(value);
      }
    }).join(',');
  });

  const csvData = [headRow, ...csvRows].join("\n");
  const blob = new Blob([csvData], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('download', 'PayDay.csv');
  a.click();
}

function convertToCsvBoolean(value) {
  if (typeof value === "string") {
    value = value.toLowerCase().startsWith("y");
  } else {
    value = !!value;
  }
  return value ? "Y" : "N";
}

function convertToCsvString(value) {
  if (typeof value === "boolean") {
    return convertToCsvBoolean(value);
  }
  if (value == null) {
    return "";
  }
  if (typeof value === "string") {
    if (value.includes("\n") || value.includes("\r")) {
      value = value.replace(/[\r\n]/g, " "); // remove line breaks from CSV
    }
    if (value.includes(",") || value.includes("\"")) {
      value = value.replace(/"/g, "\"\""); // double up quotes
      value = `"${value}"`; // wrap in quotes
    }
    return value;
  }
  return value.toString();
}

function numberFromStatus(status) {
  if (status === null) {
    return 1;
  }
  if (status === "approved") {
    return 0;
  }
  if (status === "rejected") {
    return -1;
  }
  return -2;
}

const mapStateToProps = (state) => ({
  user: state.user,
  students: state.students.studentlist,
  redirect: state.redirect,
  entries: state.students.studententriesadmin
});

export default withRouter(connect(mapStateToProps)(StudentEntries));
